import { getPartFileName } from '../AiBatchIntake.utils';

/**
 * Expand a grouped segment's `parts` into one single-page pseudo-segment per
 * part so each photo renders through the existing per-source preview
 * mechanism (IntakeSegmentPreview loads one source and shows its page range).
 *
 * @param {object} segment - grouped UI segment with parts/jobId
 * @returns {object[]}
 */
export const buildPartPreviewSegments = segment =>
  (segment.parts ?? []).map((part, index) => ({
    id: `${segment.id}-part-${index}`,
    pageStart: part.pageIndex + 1,
    pageEnd: part.pageIndex + 1,
    sourceIndex: part.sourceIndex,
    sourceFileName: getPartFileName(part),
    jobId: segment.jobId,
    truncated: false,
  }));
